export interface IGetLimitedUsersRequest {
        name: string;
    }

    export class GetLimitedUsersRequest implements IGetLimitedUsersRequest {
        name: string;
    }